import React from "react";
import { Box, Paper, Skeleton } from "@mui/material";

const LoadingSkeleton: React.FC = () => (
	<Box px={6} py={2}>
		{/* Header Skeleton */}
		<Paper
			elevation={0}
			sx={{
				mb: 4,
				borderRadius: 3,
				overflow: "hidden",
				background: "white",
				p: 3
			}}
		>
			<Skeleton variant="text" width="40%" height={40} sx={{ mb: 1 }} />
			<Skeleton variant="text" width="25%" height={24} sx={{ mb: 3 }} />
			<Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2 }} />
		</Paper>

		{/* Accordion Skeletons */}
		{[1, 2, 3].map(index => (
			<Paper
				key={index}
				elevation={0}
				sx={{
					mb: 2,
					borderRadius: 2,
					overflow: "hidden",
					background: "white",
					p: 2
				}}
			>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Skeleton variant="text" width="30%" height={32} />
					<Skeleton
						variant="rectangular"
						width={120}
						height={32}
						sx={{ borderRadius: 2 }}
					/>
				</Box>
			</Paper>
		))}
	</Box>
);

export default LoadingSkeleton;
